module.exports = __webpack_public_path__ + "img/img_bg@2x.6515bae7.png";